// components/admin/TopBar.tsx
import {
  Toolbar, Typography, IconButton, Avatar, Menu, MenuItem, Box, useMediaQuery, useTheme
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  Menu as MenuIcon,
} from '@mui/icons-material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';

interface TopBarProps {
  onMenuClick: () => void;
}

const TopBar = ({ onMenuClick }: TopBarProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => setAnchorEl(null);
  const handleLogout = async () => {
    await signOut(auth);
    navigate('/admin/login');
  };

  return (
    <Toolbar sx={{ justifyContent: 'space-between' }}>
      <Box display="flex" alignItems="center">
        {isMobile && (
          <IconButton color="inherit" edge="start" onClick={onMenuClick} sx={{ mr: 1 }}>
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" fontWeight="bold" color="primary" noWrap>
          관리자 대시보드
        </Typography>
      </Box>
      <Box>
        <IconButton onClick={handleMenuClick}>
          <Avatar sx={{ width: 32, height: 32 }}>A</Avatar>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={() => { handleMenuClose(); navigate('/admin/settings'); }}>
            <SettingsIcon sx={{ mr: 1 }} /> 설정
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <LogoutIcon sx={{ mr: 1 }} /> 로그아웃
          </MenuItem>
        </Menu>
      </Box>
    </Toolbar>
  );
};

export default TopBar;
